var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.197 19.117V14.02c0-2.757-1.562-4.01-3.557-4.01-1.648 0-2.342.836-2.776 1.504V10.26H9.741V19.2h3.123v-5.013c0-.25 0-.5.087-.752.26-.5.694-1.086 1.561-1.086 1.128 0 1.562.836 1.562 2.005v4.762zM6.532 9.006c1.04 0 1.735-.668 1.735-1.503C8.267 6.668 7.573 6 6.532 6s-1.735.585-1.735 1.42c0 .836.694 1.588 1.735 1.588m1.561 10.11v-8.94H4.97v8.94z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.799 6h14.4v13.2h-14.4z"
  })))));
};
export default SvgLinkedin;